import request from '@/config/axios'
const paths = { video: '/ai/video', ppt: '/ai/ppt', avatar: '/ai/avatar', avatarVideo: '/ai/avatar-video' }
export type AiContentKind = keyof typeof paths
export const getAiContentPage = (kind: AiContentKind, params: any) => request.get({ url: `${paths[kind]}/page`, params })
export const auditAiContent = (kind: AiContentKind, id: number, publicStatus: boolean) => request.post({ url: `${paths[kind]}/audits-publish`, data: { id, publicStatus } })
